import { lazy } from "react";

const routes = [
  {
    path: "/settings/nodal-points",
    element: lazy(() => import("../../pages/Settings/NodalPoints")),
  },
];

export default routes;
